/**
 * Singleton instance of LocationService
 * Shared across all location selector components to maintain unified cache
 * 
 * Uses local Vercel serverless functions backed by @countrystatecity/countries.
 * No external API key required.
 */

import { LocationService } from './LocationService';
import { CountryStateCityClient } from './api/CountryStateCityClient';
import { LocationCache, RecommendedTTL } from './cache/LocationCache';

let locationServiceInstance: LocationService | null = null;

/**
 * Get or create the singleton LocationService instance
 */
export function getLocationService(): LocationService {
  if (!locationServiceInstance) {
    const apiClient = new CountryStateCityClient();
    const cacheManager = new LocationCache();
    
    locationServiceInstance = new LocationService({
      apiClient,
      cacheManager,
      ttl: RecommendedTTL
    });
  }
  
  return locationServiceInstance;
}

/**
 * Reset the singleton instance (useful for testing)
 */
export function resetLocationService(): void {
  locationServiceInstance = null;
}
